import React from 'react'
import { Card, PageHeader, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/recording_table'
import RecordingService from '../../network/services/recording'
import { serialize } from '../../network/request'
import RecordingTable from './RecordingTable'

const RecordingPage = () => {
  return (
    <PageHeader title="All Recordings">
      <Card>
        <RecordingTableWrapper />
      </Card>
    </PageHeader>
  )
}

const RecordingTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(RecordingService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = RecordingService.toPaginate(response)

  return (
    <>
      <RecordingTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <RecordingTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default RecordingPage
